import PrimaryDefaultButton from '@/components/buttons/primary/DefaultButton';
import styled from 'styled-components';

const PrimaryInnerGlowButton = styled(PrimaryDefaultButton)`

`;

export default PrimaryInnerGlowButton;
